import BasePerimeter from './basePerimeter';

export default new BasePerimeter({
  purpose: 'operators',
  govern: {
    'can route': function route() {
      return this.isAdmin();
    },
    'can createOperator': function createOperator() {
      return this.isAdmin();
    },
  },
});



// WEBPACK FOOTER //
// ./src/perimeters/operatorsPerimeter.js